import React, {
  createContext,
  useState,
  useContext,
  useCallback,
} from "react";
import { listAllApprovedProperties } from "../services/api/properties";
// Importe sua função de imobiliárias se ela existir em outro serviço ou mantenha o map se vier de outro lugar
import { listRealEstates } from "../services/api/real_estates"; 

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const [properties, setProperties] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [realEstatesMap, setRealEstatesMap] = useState({});

  // Função unificada que o HorizontalBar e as páginas de filtro vão usar
  const fetchApprovedProperties = useCallback(
    async ({ pageParam = 1, limitParam = limit, filtersParam = filters } = {}) => {
      try {
        setIsLoading(true);

        const response = await listAllApprovedProperties(
          pageParam,
          limitParam,
          filtersParam
        );

        setProperties(response.properties || []);
        setTotal(response.total || 0);
        setPage(pageParam);
        setLimit(limitParam);
        setFilters(filtersParam);
        
        return response.properties || []; // Retornamos para uso direto no dropdown
      } catch (error) {
        console.error("Erro ao buscar imóveis:", error);
        setProperties([]);
        setTotal(0);
        return [];
      } finally {
        setIsLoading(false);
      }
    },
    [limit, filters]
  );

  // Carrega o mapa de imobiliárias uma única vez para o app todo usar
  const fetchRealEstatesMap = useCallback(async () => {
    try {
      const list = await listRealEstates();
      const map = list.reduce((acc, re) => {
        acc[re.id] = re.nomeFantasia || re.nome || re.razaoSocial || re.full_name;
        return acc;
      }, {});
      setRealEstatesMap(map);
    } catch (e) {
      console.error("Erro ao carregar mapa de imobiliárias", e);
    }
  }, []);

  return (
    <PropertyContext.Provider
      value={{
        properties,
        total,
        page,
        limit,
        filters,
        isLoading,
        realEstatesMap,
        fetchApprovedProperties,
        refetchProperties: fetchApprovedProperties,
        fetchRealEstatesMap,
        setPage,
        setLimit,
        setFilters,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => useContext(PropertyContext);